// extracted by mini-css-extract-plugin
module.exports = {"container":"TextImageElement__container","imageRight":"TextImageElement__imageRight","imageWrapper":"TextImageElement__imageWrapper","image":"TextImageElement__image"};